



















import { Vue, Component, Prop } from 'vue-property-decorator';
import { SVG } from '@svgdotjs/svg.js';
import { SignatureConstants } from '@lib-shared/signature/constants/signature.constants';
import { SignatureHelper } from '@/helpers/signature.helper';
import CharacterCounter from '@lib-shared/components/CharacterCounter.vue';
import PinyonScript from '@signing-page/signing/constants/pinyon-script';
import type { IRecipient } from '@signing-page/documents/types/recipient';
import '@svgdotjs/svg.js/dist/polyfillsIE.js';

@Component({
  components: {
    CharacterCounter,
  },
  data: () => ({
    writeSignatureWidth: SignatureConstants.writeSignatureWidth,
    writeSignatureHeight: SignatureConstants.writeSignatureHeight,
  }),
})
export default class WriteSignature extends Vue {
  @Prop() recipient: IRecipient;
  inputText = '';
  canvas: any = null;
  ctx: any = null;
  showWriteSignature = false;
  loaderTimeout = 500;
  fontFamily: string = SignatureConstants.writeSignatureFont;
  draw;
  maxLength = 40;

  setCanvasData() {
    this.canvas = document.createElement('canvas');
    this.canvas.width = SignatureConstants.writeSignatureWidth;
    this.canvas.height = SignatureConstants.writeSignatureHeight;
    this.ctx = this.canvas.getContext('2d');
  }

  setStaticData() {
    this.ctx.fillStyle = SignatureConstants.writeSignatureColor;
    this.ctx.textAlign = SignatureConstants.writeSignatureAlign;
  }

  setDynamicData() {
    const fontSize: number = this.canvas.height * 0.6 - (this.inputText.length - 12) * 5;
    this.ctx.font = `${fontSize}px ${this.fontFamily}`;
    this.ctx.font = this.ctx.fillText(
      this.inputText,
      this.canvas.width / 2,
      this.canvas.height * 0.7,
      this.canvas.width * 0.7
    );
    const signatureNative = SignatureHelper.convertSignature(this.ctx, this.canvas);
    const signatureBase30 = SignatureHelper.nativeToBase30(signatureNative);

    if (this.draw) {
      const base64 = SignatureHelper.encodeUnicodeToBase64(this.draw.svg());
      const signatureBase64 = `${SignatureConstants.saveWriteType},${base64}`;

      this.$emit('signature', {
        signatureBase30,
        signatureBase64,
      });
    }
  }

  setSvgData() {
    if (this.draw) {
      this.draw.remove();
    }

    this.draw = SVG().addTo('#svg-signature').size('100%', '100%');
    this.draw.style(PinyonScript);
    const text = this.draw
      .text(this.inputText)
      .font({ family: this.fontFamily, size: 12, fill: '#3b3b3b' });
    const boundingRect = text.node.getBoundingClientRect();
    const boundingRectParent = this.draw.node.getBoundingClientRect();
    const bbox = {
      width: boundingRect.width,
      height: boundingRect.height,
      y: boundingRect.top - boundingRectParent.top,
      x: boundingRect.left - boundingRectParent.left,
    };
    this.draw.viewbox(
      -10,
      -10,
      bbox.x + bbox.width + bbox.x + 20,
      bbox.y + bbox.height + bbox.y + 20
    );
  }

  handleChange() {
    this.setSvgData();
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.setDynamicData();
  }

  mounted() {
    this.setCanvasData();
    this.setStaticData();
    this.setDynamicData();
    setTimeout(() => {
      this.inputText = this.recipient.fullName;
      this.showWriteSignature = true;
      this.handleChange();
    }, this.loaderTimeout);
  }
}
